import { render } from "./StudentsSelection.vue?vue&type=template&id=62b4178f&scoped=true"
import script from "./StudentsSelection.vue?vue&type=script&lang=js"
export * from "./StudentsSelection.vue?vue&type=script&lang=js"

import "./StudentsSelection.vue?vue&type=style&index=0&id=62b4178f&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Management_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b4178f"]])

export default __exports__